module.exports = __webpack_public_path__ + "static/img/pic_nothing.a67ddeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic_nothing.png
// module id = bNXC
// module chunks = 1